<template>
  <div>
    <b-modal
      id="your-consultant-modal"
      ref="your-consultant-modal-ref"
      hide-footer
      title="Your Consultant"
    >
      <b-card-body>
        <div class="consultant-info-header">
          <h2 v-if="booking && booking.consultant_information" class="mt-2">{{ booking.consultant_information.name }}</h2>
          <img
            v-if="getConsultantImage"
            :src="`https://www.trailfinders.com${getConsultantImage}`"
            alt="Consultant"
            class="consultant-img custom-consultant-img"
          />
          <b-button
            v-if="
              (getFil === 'P' && booking.feedback_exists !== true) ||
              (booking && booking.numDaysSinceAuth <= 10 &&
                booking.feedback_exists !== true)
            "
            id="consultant-feedback-btn"
            class="btn-consultant btn-consultant-how btn-info mt-2"
            @click="showFeedbackModal"
          >
            <span>How did I do today?</span>
          </b-button>
          <div
            v-if="
              booking && booking.consultant_information && booking.consultant_information.branchContact &&
              booking.consultant_information.branchContact[0].line0.telno
            "
            class="contact-no mb-1 d-flex align-items-center"
          >
            <i class="material-icons icon mr-2">&#xE61D;</i>
            {{ booking.consultant_information.branchContact[0].line0.telno }}
          </div>
          <a
            href="https://www.trailfinders.com/contact"
            target="_blank"
            class="tc-link m-2"
            >Your local Travel Centre</a
          >
        </div>
      </b-card-body>

      <b-button id="close-btn" class="mt-3" block @click="hide()">
        Close
      </b-button>
    </b-modal>
    <Feedback ref="FeedbackRef" :email="booking && booking.user_information ? booking.user_information.email : ''" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Feedback from "../../../booking/feedback.vue";
import { getTrustPilotURL } from "@/modules/booking/services.js"

export default {
  components: {
    Feedback,
  },
  data() {
    return {
      bioimage: null,
    };
  },
  computed: {
    ...mapState({
      booking: (state) => state.booking.booking,
    }),
    ...mapGetters("booking", [
      "getBookingInfo",
      "getConsultantInformation",
      "getConsultantImage",
      "getFil",
      "getBookingPassengers"
    ]),
    isInsuranceOnly() {
      return this.getDestination === "INS" ? true : false;
    },
    ...mapActions("booking", ["getConsBioImages"]),
  },
  methods: {
    async showModal() {
      this.$refs["your-consultant-modal-ref"].show();
    },
    hide() {
      this.$refs["your-consultant-modal-ref"].hide();
    },
    async showFeedbackModal() {
      const tpurl = await getTrustPilotURL(this.booking.user_information.bookingNumber, this.getBookingPassengers[0])
      if(tpurl) this.$refs.FeedbackRef.showModal(tpurl);
    }
  },
};
</script>

<style>
@import "./styles.scss";
</style>
